<template>
<!--海外采购数据筛选-->
  <div class="content">
    <el-row type="flex">
      <el-col :span="6"  class="leftMenu ">
        <!-- 左侧 -->
        <div :class="{'contentLeft': true, 'enable-overflow-y fine-scroll-bar': modelIndex === 0}">
          <div class="contentLeftTitel">海外采购数据筛选</div>
          <div class="search-models">
            <div 
              :class="{'search-models-item': true, 'active': modelIndex === 0}"
              @click="changeTab(0)"
            >搜索</div>
            <div 
              :class="{'search-models-item': true, 'active': modelIndex === 1}"
              @click="changeTab(1)"
            >已保存的搜索</div>
            <div class="search-models-block"></div>
          </div>
          <el-form v-if="modelIndex === 0" class="contentLeftform">
            <!-- 关键字 -->
            <el-form-item :label="'关键字'">
              <el-input size="small" v-model="searchData.keyword" placeholder="工艺 | 行业 | 产品 | 联系人姓名" maxlength="63" clearable @blur="searchBtnShow"></el-input>
            </el-form-item>
            <!-- 公司名称 -->
            <el-form-item :label="'公司名称'">
              <el-input size="small" v-model="searchData.compName" placeholder="请输入公司名" maxlength="200" clearable @blur="searchBtnShow"></el-input>
            </el-form-item>
            <!-- 国家 -->
            <el-form-item :label="'国家/区域'">
              <el-select 
                collapse-tags 
                multiple  
                size="small" 
                v-model="searchData.countryId" 
                placeholder="请选择国家/区域" 
                maxlength="200" 
                filterable 
                :filter-method="countryIdDataFilter" 
                clearable 
                @blur="searchBtnShow"
                @visible-change="(countryIdArr = countryIdArrFilter)"
                :loading="countryIdLoading"
              >
                <el-option
                  v-for="item in countryIdArr"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select >
            </el-form-item>
            <!-- 姓名 -->
            <!-- <el-form-item :label="'姓名'">
              <el-input size="small" v-model="searchData.contactName" placeholder="请输入姓名" maxlength="200" clearable @blur="searchBtnShow"></el-input>
            </el-form-item> -->
            <!-- 职位 -->
            <el-form-item label="职位">
              <el-input 
                size="small" 
                v-model="searchData.titleName" 
                placeholder="请输入职位，如：采购" 
                maxlength="200" 
                clearable 
                @blur="searchBtnShow"
              ></el-input>
            </el-form-item>
            <!-- 职位类别 -->
            <!-- <el-form-item label="职位类别">
              <el-select 
                v-model="searchData.titleGroupIds" 
                placeholder="请选择"
                v-loadmore="loadMore"
                :filterable="!searchData.titleGroupIds.length"
                multiple 
                collapse-tags
                size="small" 
                :remote="true" 
                :remote-method="searchAcceptorComp"
                @focus="acceptorCompFocus"
                @blur="searchBtnShow"
                clearable
                :loading="titleGroupIdsloading"
                >
                <el-option 
                  v-for="item in tempList" 
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <!-- 行业 -->
            <el-form-item :label="'行业'">
              <el-select
                multiple  
                collapse-tags size="small" 
                v-model="searchData.industry" 
                placeholder="请选择行业" 
                filterable 
                :filter-method="industryDataFilter" 
                @focus="focus"
                maxlength="500" 
                clearable 
                @blur="searchBtnShow" 
                :loading="industryLoading"
                @visible-change="(saas_customer_industry = saas_customer_industryArr)"
              >
                <el-option
                  v-for="item in saas_customer_industry"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select >
            </el-form-item>
            <!-- 雇员数量  filterable :filter-method="employeesDataFilter"-->
            <el-form-item :label="'雇员数量'">
              <el-select  multiple  collapse-tags size="small" v-model="searchData.employees" :placeholder="'请选择'"    @focus="focus" clearable @blur="searchBtnShow">
                <el-option
                  v-for="item in sass_buyer_employees"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select >
            </el-form-item>
            <!-- 企业营收 filterable  :filter-method="revenueDataFilter"-->
            <el-form-item :label="'企业营收 ($)'">
              <el-select  multiple  collapse-tags size="small" v-model="searchData.revenue"   @focus="focus"   :placeholder="'请选择'" clearable @blur="searchBtnShow">
                <el-option
                  v-for="item in sass_buyer_revenue"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select >
            </el-form-item>
            <!-- 是否有Linkedln个人主页 -->
            <!-- <el-form-item :label="'是否有Linkedln个人主页'">
              <el-select  size="small" v-model="searchData.haveLinkedIn" :placeholder="'请输入'" clearable @blur="searchBtnShow">
                <el-option
                  v-for="item in haveLinkedInData"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select >
            </el-form-item> -->
            <!-- <div class="marginBotom"></div> -->
          </el-form>
          <!-- 搜索记录 -->
          <SearchRecords 
            ref="search-record"
            v-if="modelIndex === 1" 
            @fastSearch="fastSearch"
            @rename="renameEmit"
          />
        </div>
        <div v-if="modelIndex === 0" class="butnRight">
          <div>
            <el-button class="butnRight-btn" v-no-more-click size="small" @click="saveSearchRecord" :disabled="searchBtnShow()">保存搜索</el-button>
            <el-button class="butnRight-btn" v-no-more-click @click="resets(false)" size="small">重置</el-button>
            <el-button class="butnRight-btn" v-no-more-click type="primary" size="small" @click="search(false)" :disabled="searchBtnShow()">搜索</el-button>
          </div>
        </div>
      </el-col>
      <el-col :span="18" class="list" v-loading="isLoadedRecordList == 'ing'">
        <template v-if="isLoadedRecordList !== 'ing'">
          <!-- 右侧 -->
          <!-- {{ recordsListVisible }}
          {{ recordList.length }}
          {{ isSavedSearchRecord }} -->
          <div v-if="$store.state.permissionVerification.accessData.incognitoMode==1||!(recordsListVisible && (recordList.length || isSavedSearchRecord))" class="contentRight">
            <div class="contentRightSearch" v-if="searchShow">
              <!-- 图片 -->
              <div class="contentRightSearchImg">
                <div class="SearchImg">
                  <img src="@/assets/image/common/buyersearchbg.png" alt="">
                </div>
                <div class="explain">
                  即刻开始，通过检索链接海外数据线索
                </div>
                <div class="operate">
                  通过应用左侧面板中的任何筛选器开始搜索
                </div>
              </div>
              <!-- 右侧搜索功能 -->
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-card shadow="always" class="rowCard">
                    <div class="rowCardTitle">
                      <i class="iconfont icon-icon-fangdajing"></i> 我要搜索<span class="colorBlu"> 美国 </span>的<span class="colorBlu"> 采购</span> 
                    </div>
                    <el-row :gutter="3">
                      <el-col :span="6">
                        <div class="rowCardCounter">
                          美国
                        </div>
                        <!-- <el-input v-model="rightSearchData.title" size='small' :placeholder="'请输入'" maxlength="200" clear></el-input> -->
                      </el-col>
                      <el-col :span="6">
                        <div class="rowCardCounter">采购</div>
                        <!-- <el-select  v-model="rightSearchData.countryId" size="small" :placeholder="'请输入'"  clear></el-select > -->
                      </el-col>
                    </el-row>
                    <div class="rowCardBtn">
                      <el-button v-no-more-click size="mini" type="primary" @click="rightSearch(['countryId', 'titleName'],[[92], '采购'])">试一试</el-button>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card shadow="always" class="rowCard">
                    <div class="rowCardTitle">
                      <i class="iconfont icon-icon-fangdajing"></i> 我要搜索<span class="colorBlu"> 医疗行业 </span>的客户
                    </div>
                    <div class="rowCardCounter">
                      <!-- {{rightSearchData.industry}} -->
                      医疗器械
                    </div>
                    <!-- <el-input v-model="rightSearchData.industry" size="small" :placeholder="'请输入'" maxlength="200"></el-input> -->
                    <div class="rowCardBtn">
                      <el-button v-no-more-click size="mini" type="primary" @click="rightSearch(['industry'],[[9]])">试一试</el-button>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card shadow="always" class="rowCard">
                    <div class="rowCardTitle">
                      <i class="iconfont icon-icon-fangdajing"></i> 我要搜索 <span class="colorBlu"> ABB </span>的联系人
                    </div>
                    <div class="rowCardCounter">{{rightSearchData.compName}}</div>
                    <!-- <el-input v-model="rightSearchData.compName" size="small" :placeholder="'请输入'" maxlength="200"></el-input> -->
                    <div class="rowCardBtn">
                      <el-button v-no-more-click size="mini" type="primary" @click="rightSearch(['compName'],['ABB'])">试一试</el-button>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div v-if="!searchShow" v-loading="loading">
              <!-- 右侧列表 -->
              <tableList 
                :data="tableData" 
                :totalNum="totalNum" 
                @resetsFun="resets" 
                @addManRefresh="getBuyerSearch" 
                :loading="loading" 
                @vloadingfn="vloadingfn"
                @fastSearch="$event=> fastSearch({compName: $event})"
              />
              <div class="pagetionStyle" v-if="tableData.length"> 
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="curPage"
                  :page-sizes="[50, 100, 300, 500]"
                  :page-size="pageSize"
                  layout="total, sizes,prev,pager,next, jumper"
                  :total="totalNum"
                  ref="pagina"
                  >
                </el-pagination>
              </div>
            </div>
          </div>
          <!-- 有搜索记录时              -->
          <RecordsPage 
            v-else 
            ref="records-page"
            :firstPageList="recordList"
            @fastSearch="fastSearch"
            @hideSelf="recordsListVisible = true"
          />
          <!-- @beforeDestroy="recordList = []" -->
        </template>
      </el-col>
    </el-row>
    <!-- 人机验证 --> 
    <el-dialog
      :visible.sync="updateCaptchaData"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :show-close="false"
      :withHeader="false"
      center
      custom-class="SlideCaptcha"
      >
      <!-- <div>
        智能验证
      </div> -->
      <template slot="title">
        <div class="titles" id="submitForm" >
          智能验证
        </div>
      </template >
      <SlideCaptcha
        @callbackData="callbackData"
        :lang="lang"
        :width="362"
        style="box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);margin-bottom: 30px;"
      />
    </el-dialog>
     <!-- 遮罩层 -->
    <!-- <div class="mask" v-if="updateCaptchaData">
      <div class="slideContainer">
        <slide-verify 
          @success="onSuccess" 
          @fail="onFail" 
          @refresh="onRefresh" 
          @fulfilled="onFulfilled" 
          slider-text="向右滑动验证">
        </slide-verify>
        <div style="margin-top: 15px;">{{ text }}</div>
      </div>
    </div> -->
    <!-- 新增或重命名搜索条件的名称Dialog -->
    <SaveRecordNameDialog 
      ref="save-record-dialog"
      :show="saveRecordNameDialogVisible"
      @changeShow="$event=> saveRecordNameDialogVisible = $event"
      @reloadRecords="reloadRecordsEmit"
      @changeTab="($event)=> {changeTab($event)}"
    />
  </div>
</template>
<script>
import tableList from "@/components/overseas-buyer/tableList"
import SearchRecords from "@/components/overseas-buyer/searchRecords.vue"
import RecordsPage from "@/components/overseas-buyer/recordsPage.vue"
import SaveRecordNameDialog from "@/components/overseas-buyer/saveRecordNameDialog.vue"
import {imgRes} from "@/utils/config"
import { getDictByType, } from '@/utils/api/common.js';
import {buyerSearch,countryList,searchInitData,unfreeze} from "@/utils/api/seamark"
import SlideCaptcha from '@/components/overseas-buyer/SlideCaptcha'
// import { set } from 'vue';
// import treeNodeVue from '../../components/tree-virtual/components/tree-node.vue';
import {userTitleGroupByKeyword,industryByKeyword} from "@/utils/api/edmSubject"
import { buyerSearchHistory, saveBuyerSearchHistory } from "@/utils/api/seamark"
export default {
  components:{
    tableList,
    SearchRecords,
    RecordsPage,
    SaveRecordNameDialog,
    SlideCaptcha
  },
  data(){
    return{
      modelIndex: 0,  //搜索模式tab的index
      saveRecordNameDialogVisible: false,
      recordsListVisible: false, //  搜索记录是否有结果，长度为0就不展示
      recordList: [], //搜索记录的列表
      isLoadedRecordList: 'no',  //是否在初始化时加载过历史记录，用于解决初始化会闪一下引导搜索页的现象 (no: 没有加载过， ing:正在加载， yes: 加载过)
      isSavedSearchRecord: false, //是否保存过搜索历史记录，因为会出现初始为0条历史，在点击搜索后，再点击重置，不会跳转到记录页

      text:'',
      updateCaptchaData:false,
      searchShow:true,
      imgRes:imgRes,
      total:0,
      curPage:1,
      tableData:[],
      pageSize:50,
      totalNum:0,
      searchData:{
        keyword:'',//关键字
        contactName:'',//姓名
        compName:'',//公司名称
        titleGroupIds:[],//职位类别
        titleName: '',  //职位
        countryId:[],//国家
        industry:[],//行业
        employees:[],//雇员数量
        revenue:[],//企业营收
        haveLinkedIn:'',//是否有Linkedln个人主页
      },
      //复制
      searchDataCopy:{
        keyword:'',//关键字
        contactName:'',//姓名
        compName:'',//公司名称
        titleGroupIds:[],//职位类别
        titleName: '',  //职位
        countryId:[],//国家
        industry:[],//行业
        employees:[],//雇员数量
        revenue:[],//企业营收
        haveLinkedIn:'',//是否有Linkedln个人主页
      },
      rightSearchData:{
        titleGroupIds:'Purchasing Manager',
        countryId:'United State',
        industry:9,
        compName:'ABB'
      },
      saas_customer_industry:[],//行业类型
      sass_buyer_employees:[],//采购商雇员数量
      sass_buyer_revenue:[],//采购商企业营收
      countryIdArr:[],//国家
      countryIdArrFilter:[],
      saas_supplier_customer_title:[],//职位
      // 模拟分页
      tempList: [], //模拟分页时的临时职位列表
      tempLength: 0,  //长度
      currentPage: 0, 
      currentSize: 10,
      tempLoading: false, //当前加载状态

      codeMap:{},
      lang: "cn",
      haveLinkedInData:[{
        codeValue:'0',
        name:'否'
      },
      {
        codeValue:'1',
        name:'是'
      },
      ],
      loading:true,
      titlekeyword:'',
      saas_customer_industryArr:[],
      code:0,
      // appKey: "FFFF0N0000000000924F",
      titleGroupIdsloading:false,
      countryIdLoading:false,
      industryLoading:false,


    }
  },
  computed:{
    
  },
  watch:{

  },
  methods:{
    // 左侧条件记录列表部分的Function
    changeTab(index) {
      if(this.modelIndex !== index) {
        this.modelIndex = index;
      }
    },
    fastSearch(condition) {
      this.recordsListVisible=true
      this.resets(true);
      this.searchData = {
        ...this.searchData,
        industry: condition.industryTypes || [],
        industryTypes: condition.industryTypes || [],
        ...condition
      }
      this.searchData.keyword==null?this.searchData.keyword='':this.searchData.keyword
      this.modelIndex = 0;
      this.search(true);
    },
    saveSearchRecord() {
      const _condition = {
        "keyword":this.searchData.keyword.trim(),
        "compName": this.searchData.compName.trim(),
        "contactName": this.searchData.contactName.trim(),
        "countryId": this.searchData.countryId,
        "employees": this.searchData.employees,
        // "haveLinkedIn": this.searchData.haveLinkedIn,  //貌似不收
        "industryTypes": this.searchData.industry,
        "revenue": this.searchData.revenue,
        // "titleGroupIds": this.searchData.titleGroupIds,  //貌似不收
        "titleName": this.searchData.titleName.trim(),
      };
      this.$refs['save-record-dialog'].condition = _condition;
      this.saveRecordNameDialogVisible = true;

    },
    renameEmit(id, name) {
      const el = this.$refs['save-record-dialog']
      el.recordId = id;
      el.formAlignData.name = name;
      this.saveRecordNameDialogVisible = true;
		},
    reloadRecordsEmit() {
      this.$refs['search-record'].reloadFn();
    },
    // 右侧搜索记录列表部分的Function
    async buyerSearchHistory() {
      if(this.isLoadedRecordList == 'no') {
        this.isLoadedRecordList = 'ing'
      }
			const params = {
				type: 1,	// 1搜索历史 2被保存的搜索
				// id: '', //向下滚动: id取上次结果的最后一条id;  向上滚动: id取上次结果的第一条。(第1页就为空)
				pageSize: 10,	//接口默认10
			}
			try {
				const res = await buyerSearchHistory(params);
				if(res.rspResult.bizCode==200){
					const _list = res.rspListData.list || [];
          this.recordList = _list;
          _list && _list.length && (this.recordsListVisible = this.$store.state.permissionVerification.accessData.incognitoMode==1?false:true); //是否为无痕模式 有长度代表有搜索记录，那么去展示记录列表的页面
				}else{
					this.$message.error(res.rspResult.message);
				}
        if(this.isLoadedRecordList == 'ing') {
          this.isLoadedRecordList = 'yes'
        }
			} catch (err) {
				if(this.isLoadedRecordList == 'ing') {
          this.isLoadedRecordList = 'yes'
        }
				console.log('获取海外采购搜索记录出错', err)
			}

		},
    saveBuyerSearchHistory(_condition, isFast) {
      // 保存用户的搜索历史记录
      const params = {
        keyword:this.searchData.keyword.trim(),
        compName: _condition.compName.trim(),
        contactName: _condition.contactName.trim(),
        countryId: _condition.countryId,
        employees: _condition.employees,
        haveLinkedIn: _condition.haveLinkedIn,
        industryTypes: !isFast ? _condition.industry : _condition.industryTypes,
        revenue: _condition.revenue,
        titleGroupIds: _condition.titleGroupIds,
        titleName: _condition.titleName.trim(),
      }
      saveBuyerSearchHistory(params)
        .then(res=> {
          if(!this.isSavedSearchRecord) {
            this.isSavedSearchRecord = this.$store.state.permissionVerification.accessData.incognitoMode==1?false:true;
          }
        })
        .catch(err=> {
          console.error('保存用户的搜索记录时出错', err)
        })
    },



    vloadingfn(val){
      console.log(val)
      this.loading=val
    },
    acceptorCompFocus(){
      if(!this.titlekeyword){
        this.saas_supplier_customer_title=[]
        this.tempList = [];
      }
      if(this.searchData.titleGroupIds.length==0){
        this.titlekeyword=''
        this.saas_supplier_customer_title=[]
        this.tempList = [];
      }
    },
    searchAcceptorComp(query){
      if(this.titleGroupIdsloading) return;
      console.log('输入了', query)
      let keyword = query.trim()
      if (keyword) {
        // this.loading = true;
        // this.options = [];
        // this.curPage = 1;
        this.titlekeyword = keyword;
        this.findData(keyword);
      }
    },
    findData(query){
      this.titleGroupIdsloading=true
      const params = {
        keyword: query,
      };
      this.saas_supplier_customer_title = [];
      this.tempList = [];
      userTitleGroupByKeyword(params).then(res=>{
        if(res.rspResult.bizCode==200){
          console.log(res)
          this.saas_supplier_customer_title= Object.freeze(res.rspListData.list);
          // 模拟分页
          this.tempLength = this.saas_supplier_customer_title.length;
          if(this.tempLength == 0) {
            return this.titleGroupIdsloading = false;
          };
			    this.currentPage = 0;
          this.handleSelectList();
        }
        this.titleGroupIdsloading=false

      })
    },
    // 前端模拟分页 - 处理列表
    handleSelectList(isLoadMore=false) {
			const start = this.currentPage * this.currentSize;
			if(start+1 < this.tempLength) {
				const nextList = this.saas_supplier_customer_title.slice(start, start + this.currentSize)
				if(!isLoadMore) {
					// if(!this.searchData.titleGroupIds.length) {
					// 	this.tempList = nextList;
					// }else {
					// 	// 在原来基础上再继续填充

					// }
          this.tempList = nextList;
				}else {
					this.tempList = this.tempList.concat(nextList)
				}
				this.currentPage++
			}else {
				if(!isLoadMore) {
          this.tempList = [...this.saas_supplier_customer_title];
        }
			}
			this.tempLoading = false;
		},
    // 前端模拟分页 - 加载下一页
    loadMore() {
			console.log('加载更多')
			if(this.tempLoading || this.titleGroupIdsloading) return;
			this.tempLoading = true;
			const timer = setTimeout(()=> {
				this.handleSelectList(true);
				clearTimeout(timer);
			}, 300)

		},
    // 行业自定义联想搜索
    industryDataFilter(val){
      if(val.trim().length>=2){
        this.saas_customer_industry=this.saas_customer_industryArr.filter(item=>{
          let reflag=true
          let valLen=val.trim().length
          // val!=item.name.slice(0,valLen)
          // 
          // console.log(val.toUpperCase())
         loop: if(!item.name.toUpperCase().includes(val.trim().toUpperCase())){
            reflag=false
            break  loop
          }else{
            return item
          }
          return reflag
        })
      }else{
        this.saas_customer_industry=this.saas_customer_industryArr
      }
    },
    // 国家区域联想搜索
    countryIdDataFilter(val){
      if(val.trim().length>=2){
        this.countryIdArr=this.countryIdArrFilter.filter(item=>{
          let reflag=true
          let valLen=val.trim().length
         loop: if(!item.name.toUpperCase().includes(val.trim().toUpperCase())){
            reflag=false
            break  loop
          }else{
            return item
          }
          return reflag
        })
      }else{
        this.countryIdArr=this.countryIdArrFilter
      }
    },
    // // 雇员数量自定义联想搜索
    // employeesDataFilter(val){
    //   if(val.length>=3){
    //     this.sass_buyer_employees=this.codeMap.sass_buyer_employees.filter(item=>{
    //       let reflag=true
    //       let valLen=val.length
    //      loop: if(val!=item.name.slice(0,valLen)){
    //         reflag=false
    //         break  loop
    //       }else{
    //         return item
    //       }
    //       return reflag
    //     })
    //   }else{
    //     this.sass_buyer_employees=this.codeMap.sass_buyer_employees
    //   }
    // },
    // // 企业营收自定义联想搜索
    // revenueDataFilter(val){
    //   if(val.length>=3){
    //     this.sass_buyer_revenue=this.codeMap.sass_buyer_revenue.filter(item=>{
    //       let reflag=true
    //       let valLen=val.length
    //      loop: if(val!=item.name.slice(0,valLen)){
    //         reflag=false
    //         break  loop
    //       }else{
    //         return item
    //       }
    //       return reflag
    //     })
    //   }else{
    //     this.sass_buyer_revenue=this.codeMap.sass_buyer_revenue
    //   }
    // },
    // 聚焦的时候判断
    focus(){
      this.saas_customer_industry=this.saas_customer_industryArr
      this.countryIdArr=this.countryIdArrFilter
    },
    // 根据类型批量获取字典数据
    async getInitDictByType(){
      let prams=[{"key":"sass_buyer_employees"},//采购商雇员数量
      {"key":"sass_buyer_revenue"},//采购商企业营收
      {"key":'saas_supplier_customer_title'}//职位
      ]
      const res = await getDictByType(prams)
       if(res.rspResult.bizCode==200){
        this.codeMap=res.data.codeMap
        this.sass_buyer_employees=res.data.codeMap.sass_buyer_employees
        this.sass_buyer_revenue=res.data.codeMap.sass_buyer_revenue
      }else{
        this.$message.error(res.rspResult.message);
      }
    },
    // 获取全部行业字段
    getsearchInitData(){
      this.industryLoading=true
      searchInitData().then(res=>{
        if(res.rspResult.bizCode==200){
          this.saas_customer_industry=res.rspListData.list
          this.saas_customer_industryArr=JSON.parse(JSON.stringify(this.saas_customer_industry))
          this.industryLoading=false
        }else{
          this.industryLoading=false
        }

      })
    },
    // 获取国家
    async getcountryList(){
      this.countryIdLoading=true
      const res =await countryList()
      // 过滤掉瓷器，将USA放在第一个
      let tempUSA;
      const delChina = res.rspListData.list.filter((item)=> {
        if(item.codeValue == 92) {
          tempUSA = item;
        }
        return item.codeValue !== 247 && item.codeValue !== 92
      })
      delChina.unshift(tempUSA);

      this.countryIdArr = delChina
      this.countryIdArrFilter = delChina
      this.countryIdLoading=false
    },
    // 校验搜索框
    searchBtnShow(){
      if(this.searchData.keyword.trim()==''&&this.searchData.contactName.trim()==''&&this.searchData.compName.trim()==''
      &&this.searchData.titleGroupIds.length==0&&this.searchData.titleName.trim()==''&&this.searchData.countryId.length==0
      &&this.searchData.industry.length==0&&this.searchData.employees.length==0
      &&this.searchData.revenue.length==0&&this.searchData.haveLinkedIn==''){
      return true  }else{   return false  }
      },
    // 获取数据
    async getBuyerSearch(isFast){
      this.loading=true

      let prams={
          "keyword":this.searchDataCopy.keyword.trim(),//关键字
          "compName": this.searchDataCopy.compName.trim(),
          "contactName": this.searchDataCopy.contactName.trim(),
          "countryId": this.searchDataCopy.countryId,
          "employees": this.searchDataCopy.employees,
          "haveLinkedIn": this.searchDataCopy.haveLinkedIn,
          "industryTypes": !isFast ? this.searchDataCopy.industry : this.searchDataCopy.industryTypes,
          "revenue": this.searchDataCopy.revenue,
          "titleGroupIds": this.searchDataCopy.titleGroupIds,
          "titleName": this.searchDataCopy.titleName.trim(),
          "curPage": this.curPage,
          "pageSize": this.pageSize,
          "attribute": "",
          "sortType": 0
        }
      const res = await buyerSearch(prams)
      if(res.rspResult.bizCode==200){
        this.totalNum=res.rspPageData.totalNum
        this.tableData=res.rspPageData.list
        this.recordsListVisible = false;
      }else if([603,604].includes(res.rspResult.bizCode)){
        this.code=res.rspResult.bizCode
        this.updateCaptchaData = true
      }else{
        this.$message.error(res.rspResult.message);
      }
      this.loading=false
    },
    // 翻页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize=val
      this.handleCurrentChange(1)
    },
    // 当前页
    handleCurrentChange(val) {
      this.curPage=val
      this.searchData= JSON.parse(JSON.stringify(this.searchDataCopy))
      this.getBuyerSearch()
      const listEle= document.querySelector('.el-table__body-wrapper');
      listEle.scrollTop = 0;
    },
    // 左侧搜索
    search(isFast=false){
      this.searchDataCopy= JSON.parse(JSON.stringify(this.searchData))
      this.curPage=1
      this.pageSize=50
      this.getBuyerSearch(isFast)
      this.searchShow=false
      this.recordsListVisible = false;
      // 在此顺势保存搜索历史记录
      this.saveBuyerSearchHistory(this.searchDataCopy, isFast)
    },
    // 重置
    resets(noReloadHistory){
      // 左侧重置
      this.searchData.keyword=''
      this.searchData.contactName=''
      this.searchData.compName=''
      this.searchData.titleGroupIds=[]
      this.searchData.titleName=''
      this.searchData.countryId=[]
      this.searchData.industry=[]
      this.searchData.employees=[]
      this.searchData.revenue=[]
      this.searchData.haveLinkedIn=''
      this.pageSize=50
      this.curPage=1
      // 右侧重置
      this.rightSearchData.titleGroupIds='Purchasing Manager'
      this.rightSearchData.countryId='United State'
      this.rightSearchData.industry=9
      this.rightSearchData.compName='ABB'
      console.log('resets')
      console.log(this.searchData)
      this.searchShow=true
      this.recordsListVisible = this.$store.state.permissionVerification.accessData.incognitoMode==1?false:true;
      !noReloadHistory && this.$nextTick(()=> {
        const el = this.$refs['records-page'];
        el && (()=> {
          el.searchRecordList = [];
          el.finalId = null;
          el.finalSearchTime = null;
          el.buyerSearchHistory();
        })()
      })
    },
    // 右侧搜索
    rightSearch(types=[],vals=[]){
      try {
        this.resets();
      } catch (err) {
        console.error('清空表单出现问题', err)
      }
      types.forEach((type, index)=> {
        this.searchData[type] = vals[index];
      })
      this.search()
    },
    onSuccess(times){
      this.text = '验证通过，耗时 '+ (times / 1000).toFixed(1) + '秒'
      this.updateCaptchaData=false
      this.getBuyerSearch()
    },
    onFail(){
      this.text = '验证失败'
    },
    onRefresh(){
      //点击刷新按钮
      this.text = ''
    },
    onFulfilled() {
      //验证失败自动刷新
      this.text = '重新验证'
    },
    //     //滑动验证码callback
    callbackData(val,data,captcha) {
      console.log(val)
      // const nc_token = [this.appKey, new Date().getTime(), Math.random()].join(
      //   ":"
      // );
      let params={
        code:this.code,
        path:'/seamark/buyer/search',
        scene: "ic_other",
        sceneId:data.sceneId,
        captchaVerifyParam:data.captchaVerifyParam,
      }
      unfreeze(params).then(res=>{
        console.log(res)
        if(res.rspResult.bizCode==200){
          this.getBuyerSearch()
          this.updateCaptchaData = false
        }
      })
      // if (val && val.value == "pass") {
        // this.validatePass = true;
        // this.SlideCaptchaData = val;
        // // if (this.isCheckUserMobile) {
        //   this.curPage=this.curPage+1
        //   this.updateCaptchaData=false

        // }
      // }
    },
    // reload() {
    //   // 移除组件
    //   this.updateCaptchaData = false;
    //   // 在组件移除后，重新渲染组件
    //   // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
    //   this.$nextTick(() => {
    //     this.updateCaptchaData = true;
    //   });
    // },
  },
  mounted() {
    this.getInitDictByType()
    this.getcountryList()
    this.getsearchInitData()
    console.log(this.$store.state.permissionVerification.accessData.incognitoMode)
  },
  created(){
    // 获取搜索记录
    this.buyerSearchHistory();
  }
}
</script>
<style lang="scss" scoped>
.content{
  // display: flex;
  width: 100%;
  .leftMenu{
    // overflow: auto;
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    height: calc(100vh - 96px);
    width: 258px;
    min-width: 256px;
  }
  // 细滚动条类
  .list{
    // min-height: calc(100vh - 96px);
    flex: 1;
  }
  /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
  ::v-deep .contentLeft{
    flex: 1;
    height: 0;
    background: #FFFFFF;
    padding: 0px 16px;
    display: flex;
    flex-direction: column;
    &.enable-overflow-y {
      overflow-y: auto;
    }
    .contentLeftTitel{
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 14px;
      color: #16181A;
      margin-bottom: 20px;
      padding-top: 20px;
    }
    // 切换搜索模式
    .search-models {
      // width: 224px;
      width: 218px;
      height: 36px;
      flex-shrink: 0;
      background: #EDF0F4;
      border-radius: 4px;
      position: relative;
      margin-bottom: 6px;
      &-item {
        position: absolute;
        z-index: 1;
        // width: 110px;
        width: calc((100% - 4px) / 2);
        height: 32px;
        line-height: 32px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 12px;
        color: #16181A;
        text-align: center;
        cursor: pointer;
        user-select: none;
        &:nth-child(1) {
          top: 2px;
          left: 2px;
          &.active {
            color: #066EB7;
            &~.search-models-block {
              left: 2px;
            }
          }
        }
        &:nth-child(2) {
          top: 2px;
          left: 112px;
          &.active {
            color: #066EB7;
            &~.search-models-block {
              // left: 112px;
              left: 50%;
            }
          }
        }
      }
      &-block {
        position: absolute;
        top: 2px;
        z-index: 0;
        // width: 110px;
        width: calc((100% - 4px) / 2);
        height: 32px;
        background: #FFFFFF;
        border-radius: 4px;
        transition:0.25s ease-out;
      }
    }

    .contentLeftform{
      .el-form-item--small .el-form-item__label{
        font-size: 12px;
        color: #16181A;
        font-family: SourceHanSansCN-Medium;
      }
      .el-form-item {
        margin-bottom: 14px;
        .el-input {
          &__inner {
            width: 218px;
            padding-right: 25px;
            &::placeholder {
              color: #98A3B7;
            }
          }
          // &__suffix {
          //   right: -2px !important;
          // }
        }
      }
      .el-select{
        width: 100%;
      }
      .el-input__suffix{
        right: 9px;
      }
      .marginBotom{
        margin-bottom: 100px;
      }
      // .butnRight{
      //   text-align: right;
      //   margin-top: 28px;
      //   // position: fixed;
      //   position: sticky;
      //   // width: 18%;
      //   background: #FFFFFF;
      //   bottom: 0;
      //   padding: 10px 0 22px 0px;
      //   z-index: 10;
      //   .search{
      //     margin-left: 12px;
      //   }
      // }
    }

    
  }
  .butnRight{
    flex-shrink: 0;
    text-align: center;
    background: #FFFFFF;
    box-shadow: 0 -2px 8px 0 #003b711a;
    bottom: 0;
    padding: 16px 0;
    z-index: 10;
    &-btn{
      width: 64px;
      padding-left: 0;
      padding-right: 0;
      margin-left: 12px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      &:not([disabled="disabled"]) {
        color: #4F5D78;
        &[class~="el-button--primary"] {
          color: #fff;
        }
      }
      &:nth-child(1) {
        margin-left: 0;
      }
    }
  }
  .contentRight{
    margin-left:12px;
    background: #FFFFFF;
    // padding-top:18px;
    // width: 80%;
    height: 100%;

    ::v-deep .contentRightSearch{
      padding: 0px 49px;
      .contentRightSearchImg{
        text-align: center;
        margin-bottom:calc(40 / 1200 * 100%);
        padding-top: calc(48 / 1200 * 100%);
        .SearchImg{
          text-align: center;
          width: 191px;
          height: 106px;
          // background: gray;
          margin: 0 auto;
           margin-bottom:calc(48 / 1200 * 100%);
          img{
            width: 100%;
            height: 100%;
          }
        }
        .explain{
          font-family: SourceHanSansCN-Bold;
          font-weight: 700;
          font-size: 16px;
          color: #16181A;
          letter-spacing: 0;
          margin-bottom: 8px;
        }
        .operate{
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #4F5D78;
          letter-spacing: 0;
        }

      }
      .rowCard{
        .el-card__body{
          padding: 16px;
        }
        .el-input--small .el-input__inner{
          background: #F5F7FA;
        }
        .rowCardTitle{
          margin-bottom: 14px;
          color: #16181aff;
          font-size: 12px;
          font-face: SourceHanSansCN;
          font-weight: 400;
        }
        .rowCardBtn{
          margin-top: 28px;
          text-align: right;
        }
      }
    }
  }
}
.haizol-main-wrapper{
  .default-main{
    // padding: 12px;
    background: #F5F7FA;
  }
 ::v-deep .el-scrollbar {
    &-wrap {
      .el-scrollbar__view {
        min-height: auto !important;
      }
    }
  }
} 
.pagetionStyle{
  text-align: center;
  margin-top: 20px;
  ::v-deep .is-background{
    .btn-prev,.btn-next,.el-pager>li{
      background: #FFFFFF;
      border: 1px solid #CFD5DF;
      border-radius: 6px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: #066EB7 !important;
    }
    // .btn-prev{
    //   background: #FFFFFF;
    //   border: 1px solid #CFD5DF;
    //   border-radius: 6px;
    // }
  }
}
.iconfont{
  font-size: 12px;
}
.rowCardCounter{
    background: #F5F7FA;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #16181A;
    line-height: 32px;
    padding: 0px 12px;
    overflow:hidden;        //超出的文本隐藏
    text-overflow:ellipsis; //用省略号显示
    white-space:nowrap;     //不换行
}
.colorBlu{
  color: #066eb7ff;
}
.mask {
  position: fixed;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  z-index: 100;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
}
.mask .slideContainer {
  position: absolute;
  left: 50%;
  top: 50%;
  background-color: rgb(255, 255, 255);
  transform: translate(-50%,-50%);
  padding: 15px;
}

::v-deep .fine-scroll-bar {
    .el-table__body-wrapper{
    scrollbar-width: thin !important;//滚动条变细，为none时隐藏滚动条
    // 更改滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 53%, 0.4);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: hsla(0, 0%, 53%, 0.1);
    }
  }
}
</style>
<style lang="scss">
.SlideCaptcha{
  width: 412px;
  .el-dialog__body{
    padding: 0px 30px 1px 20px;
  }
  .titles{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181A;
    text-align: left;
  }
}
</style>